// extracted by mini-css-extract-plugin
module.exports = {"rightCorner":"EllipsesMenu_rightCorner__ps8Zq"};